import { useAuth } from "@/libs/auth";
import { RouteConstant } from "@/routes/routeConstant";
import { baseURL, playStoreUrl } from "@/services/api";

import { Navigate } from "react-router-dom";

import "../scss/index.scss";
import { ROLES } from "@/libs/authorization";
import { Link } from "@/components/Elements";

export const Landing = () => {
  const { isLoggedIn, role } = useAuth();

  if (isLoggedIn) {
    if (role == ROLES.ADMIN) {
      return <Navigate to={{ pathname: RouteConstant.Account }} />;
    } else if (role == ROLES.MERCHANT) {
      return <Navigate to={{ pathname: RouteConstant.Adverts }} />;
    }
    return <Navigate to={{ pathname: RouteConstant.Posts }} />;
  }

  return (
    <div className="landingPage">
      <section className="banner">
        <div className="container">
          <div className="row">
            <div className="col-sm-6">
              <div className="banner-content">
                <div className="logo">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                    alt=""
                  />
                  <span className="color-purple">Aas</span>Pass
                  <span className="color-purple">Hub</span>
                </div>
                <h1>Post</h1>
                <p>
                  You can create and publish post for specific location. You can
                  also see post available near to your location.
                </p>
                <div className="banner-btn-grp">
                  <a className="btn btn-banner play-store" href={playStoreUrl}>
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/playstore.png`}
                      alt=""
                    />
                  </a>
                  <button className="btn btn-banner app-store">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/appstore.png`}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <img
                className="banner-img"
                alt=""
                src={`${process.env.PUBLIC_URL}/assets/images/phone2.png`}
              />
            </div>
          </div>
        </div>
      </section>
      <section className="ab-us sec-pad">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 text-center">
              <img
                className="banner-img"
                alt=""
                src={`${process.env.PUBLIC_URL}/assets/images/phone3.png`}
              />
            </div>
            <div className="col-sm-6">
              <div className="ab-content">
                <div className="numb">01</div>
                <h3 className="sm-title">Ready to get started?</h3>
                <ul className="ab-list">
                  <li>Can sign up with google, facebook or twitter.</li>
                  <li>
                    Can register for new account with some limited information.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 text-center">
              <img
                className="banner-img"
                alt=""
                src={`${process.env.PUBLIC_URL}/assets/images/phone4.png`}
              />
            </div>
            <div className="col-sm-6">
              <div className="ab-content">
                <div className="numb">02</div>
                <h3 className="sm-title">Chat</h3>
                <ul className="ab-list">
                  <li>Chat with users who commented or likes on your post.</li>
                  <li>Chat with users available near to your location.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer className="main-footer">
        <div className="container">
          <div className="row">
            <div className="col-sm-4">
              <div className="logo footer-logo">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                  alt=""
                />
                <span className="color-purple">Aas</span>Pass
                <span className="color-purple">Hub</span>
              </div>
              <p>Suite 216, Berberis House, Highfield Road</p>
              <p>Feltham, Middlesex, England, TW13 4GS</p>
              <p className="mt-3">
                <strong>Phone:</strong>{" "}
                <span>+44 20 8638 0727 / +44-7584 993 771</span>
              </p>
              <p>
                <strong>Email:</strong> <span>contact@proximat8.com</span>
              </p>
            </div>
            <div className="col-sm-4">
              <div className="flinks">
                <h3>Useful Links</h3>
                <a href="#">Home</a>
                <Link to={RouteConstant.Login}>Login</Link>
                <a href="#">About us</a>
                <a href="#">Services</a>
                <a href={`${baseURL}templates/termsandconditions.html`}>
                  Terms of service
                </a>
                <a href={`${baseURL}templates/privacypolicy.html`}>
                  Privacy policy
                </a>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="flinks">
                <h3>Get the app</h3>
                <a className="btn btn-footer play-store" href={playStoreUrl}>
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/playstore.png`}
                    alt=""
                  />
                </a>
                <button className="btn btn-footer app-store">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/appstore.png`}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
          <div className="copyright">
            © 2024 <span className="color-green">AasPassHub</span>, All rights
            reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};
